<script setup>
defineProps({
  viewType: {
    type: String,
    default: 'list',
  },
})
</script>

<template>
  <div
    :class="{
      'flex flex-col space-y-4': viewType !== 'grid',
      'grid gap-4 xl:grid-cols-2 2xl:grid-cols-3': viewType === 'grid',
    }"
  >
    <slot />
  </div>
</template>
